const drawerWidth = 200;
export const useStyles = (theme) => ({
  root: {
    marginLeft: drawerWidth,
    minHeight: "100vh",
    padding: 30,
    marginTop: 50,
    backgroundColor: "#f9f9fc",
    [theme.breakpoints.down(960)]: {
      marginLeft: "auto",
      marginRight: "auto",
      padding: 20,
    },
  },
  nameInputWithMargin: {
    width: "32%",
    marginRight: 12,
    [theme.breakpoints.down(960)]: {
      width: "100%",
    },
  },
  inputWithMargin: {
    width: "49%",
    marginRight: 15,
    [theme.breakpoints.down(960)]: {
      width: "100%",
    },
  },
  inputWithoutMargin: {
    width: "49%",
    [theme.breakpoints.down(960)]: {
      width: "100%",
    },
  },
  inputRoot: {
    height: 70,
  },
  labelRoot: {
    fontSize: 18,
    fontWeight: "bolder",
    backgroundColor: "#f9f9fb",
    paddingRight: 5,
  },
  notchedOutline: {},
  labelFocused: { color: "black !important" },
  focused: {
    "& $notchedOutline": {
      borderColor: "black !important",
    },
  },
  buttonStyle: {
    background: "#0a1f3a !important",
    outlineColor: "#0a1f3a !important",
    color: "#ffffff",
    fontSize: 18,
    borderRadius: 20,
    textTransform: "none",
    marginRight: 15,
    marginBottom: 10,
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#eee !important",
      borderColor: "#0a1f3a !important",
      color: "#181818",
    },
  },
  messageLoading: {
    fontSize: 25,
    fontWeight: "bold",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
});
